import { Button } from "antd";
import React from "react";
import {
  useDispatch,
  useSelector
} from "react-redux";
import { useHistory, useLocation } from "react-router";
import { AddExpense, expenses } from "../../actions/expenses/expenses";
import { UserReportLinkExp } from "../../actions/reports";
import credit from "../../assets/icons/credit.png";
import debit from "../../assets/icons/debit.png";
import reversal from "../../assets/icons/reversal.svg";
import { amountFormat, hasAccess } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import Table from "../Common/Table/Table";
import PageHeader from "../PageHeader";
import './expenses.css';


const columns = [
  {
    title: "Expense ID",
    dataIndex: "transaction_number",
    key: "transaction_number",
    render: (text, record) => <div className={`render_common_style status_${record?.status}`}>{text}</div>
  },
  {
    title: "Expense Date & Time",
    dataIndex: "transaction_date",
    key: "transaction_date",
  },
  {
    title: "Merchant",
    dataIndex: "merchant_name",
    key: "merchant_name",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => (
      <div>
        <img
          src={record?.transaction_type === "reversal" ? reversal : record?.transaction_type === "credit" ? credit : debit}
          width={10}
          alt="credit"
        />{" "}
        <BaseCurrency />{`${amountFormat(text)}`}

      </div>
    ),
  },
  {
    title: "Purpose",
    dataIndex: "purpose",
    key: "purpose",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Is Reimbursable",
    dataIndex: "claim_reimbursement",
    key: "claim_reimbursement",
    render: (text) => text ? "Yes" : "No"
  },
  // {
  //   title: "Card ref Number",
  //   dataIndex: "card_reference_number",
  //   key: "card_reference_number",
  // },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text) => <div className={`status status_${text}`}>{text === "pending" ? "Saved" : text.replace(/_/g, ' ')}</div>,
  },
  // {
  //   title: "",
  //   dataIndex: "status",
  //   key: "status",
  //   fixed: "right",
  //   render: (text, record) => (
  //     <Space key={record.id} size="middle">
  //       <button ><img src={EditIcon} alt={"logo"} className="action-logo" /></button>
  //       <button ><img src={DeleteIcon} alt={"logo"} className="action-logo" /></button>
  //     </Space>
  //   ),
  // },
];

const Expenses = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const [expensesData, setExpensesData] = React.useState([]);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const expensesResponse = useSelector(state => state.expenses.expenses || {});
  const addExpenseResponse = useSelector(state => state.expenses.addExpense || {});
  const [filters, setFilters] = React.useState({});
  const is_admin = useSelector((state) => state?.auth?.localVariables?.is_admin);
  const [page, setPage] = React.useState(1);
  const userReportLinkExpResponse = useSelector(
    (state) => state.reports.userReportLinkExp || {}
  );
  const location = useLocation();
  // const policyViolations = useSelector((state) => state.auth?.localVariables.policyViolations || []);
  // const policyViolationsModal = useSelector((state) => state.auth?.localVariables.policyModal || false);

  React.useEffect(() => {
    const { data: { status = '' } = {} } =
      userReportLinkExpResponse;
    if (status) {
      dispatch(expenses());
      dispatch({
        type: AddExpense.RESET
      })
      dispatch({
        type: UserReportLinkExp.RESET
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkExpResponse]);

  React.useEffect(() => {
    if (is_admin !== "" && !location.state?.isEdit && !location.state?.createNew) {
      if (location.state?.status) {
        dispatch(expenses({ status: location.state?.status }))
        setFilters({
          status: location.state?.status
        })
      } else {
        dispatch(expenses());
      }
    }

    if (location.state?.createNew) {
      history.replace("/expenses")
      handleButtonClick()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_admin]);

  React.useEffect(() => {
    const { data: { response: { transactions = [] } = {}, status = false, total_records = 0 } = {} } = expensesResponse;
    if (status) {
      setExpensesData(transactions);
      setTotalRecords(total_records);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expensesResponse]);

  React.useEffect(() => {
    const { data: { status = false } = {} } = addExpenseResponse;
    if (status) {
      dispatch(expenses());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addExpenseResponse]);


  const handleSearch = (value) => {
    dispatch(expenses({ ...filters, search_key: value }));
    setFilters({
      ...filters,
      search_key: value,
    });
    setPage(1)

  }

  const handleRowClick = (evt, record) => {
    evt.preventDefault();
    if (record) {
      history.push({ pathname: `/expense-details/${record.id}`, state: { expenseData: { ...record, isFromExpense: true }, status: filters.status } });
    }
  };

  function handleButtonClick() {
    // showModal();
    history.push("/expense-add")
  }

  const handleFilter = (value) => {
    if (value === "true") {
      dispatch(expenses());
    } else {
      dispatch(expenses({ ...filters, status: value }));
      setFilters({
        ...filters,
        status: value,
      });
    }
    setPage(1)

  };


  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Expenses`}
          navigation={{
            Home: hasAccess("dashboard", "read") || hasAccess("dashboard", "write") ? "/dashboard" : "",
            Expenses: "/expenses/",
          }}
        />
      </div>

      {/* <Button
        onClick={handleButtonClick}
        className="addNew primaryButton"
        style={{ marginTop: "16px" }}
      >
        New Expense
      </Button> */}
      {/* <Button
        onClick={handleBulkButton}
        className="addNew primaryButton"
        style={{ marginTop: "16px", marginRight: "15px" }}
      >
        Bulk Expense
      </Button> */}

      {/* <Modal
        title={
          <Title level={4}>
            Policy Violation Information
          </Title>
        }
        visible={policyViolationsModal}
        onCancel={() => {
          dispatch({
            type: ExpenseViolationsReset
          })
        }}
        footer={[]}
      >
        <div className="violations">
          {policyViolations?.map((ele, idx) => (<div className="item">
            {idx + 1}. {ele.transaction_number} -
            {ele.policies?.map(itm => itm.errors.map(e => <span className={itm.is_warning ? "warn" : ""} >
              <img src={itm.is_warning ? warn : block} alt="" width={12} />  {e}
            </span>))}
          </div>))}
        </div>
      </Modal> */}
      <Table
        columns={columns}
        data={expensesData}
        isTopFilter={true}
        activeButton={location?.state?.status}
        handleRowClick={handleRowClick}
        handleSearch={handleSearch}
        placeholder={"Search by Id, Merchant"}
        scroll={{
          x: 1600
        }}
        handleFilter={handleFilter}
        handleSort={(key) => {
          dispatch(expenses({ ...filters, sort_key: key }));
          setFilters({
            ...filters,
            sort_key: key,
          });
          setPage(1)

        }}
        dotMenu={is_admin ? ["amount", "transaction_date", "employee_name", "merchant_name"] : ["amount", "transaction_date", "merchant_name"]}
        className="tableStyled"
        pagination={{
          showSizeChanger: false, total: totalRecords || 0,
          current: page,
          onChange: (pagee) => {
            dispatch(expenses({ page: pagee, ...filters }))
            setPage(pagee)
          }
        }}
        topFilters={[
          { label: "All Expenses", filter: "" },
          { label: "Saved", filter: "pending" },
          { label: "Reported", filter: "reported" },
          { label: "Pending Reimbursements", filter: "pending_reimbursement" },
          { label: "Rejected", filter: "rejected" },
          { label: "Reimbursed", filter: "reimbursed" },
          { label: "Pending Approval", filter: "pending_approval" },
        ]}
        is_admin={is_admin}
        module="Expense"
        handleAddButton={handleButtonClick}
      />
    </>
  );
};

export default Expenses;
